export const GET_CALENDY_STUDENTS = "GET_CALENDY_STUDENTS";
export const GET_CALENDY_STUDENT_BY_ID = "GET_CALENDY_STUDENT_BY_ID";
export const UPDATE_CALENDY_STUDENT = "UPDATE_CALENDY_STUDENT";
export const DELETE_CALENDY_STUDENT = "DELETE_CALENDY_STUDENT";
export const CREATE_CALENDY_STUDENT = "CREATE_CALENDY_STUDENT";
